import type { ReactElement, ReactNode } from "react";
import React, { createContext, useContext } from "react";

const Context = createContext<undefined | string>(undefined);

type ApiUrlProviderProps = {
	readonly url: string;
	readonly children: ReactNode;
};

function ApiUrlProvider({ url, children }: ApiUrlProviderProps): ReactElement {
	return <Context.Provider value={url}>{children}</Context.Provider>;
}

function useApiUrl(): string {
	const url = useContext(Context);
	if (url === undefined) {
		throw new Error("No API URL context");
	}
	return url;
}

export { ApiUrlProvider, useApiUrl };
